import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const notificationsApi = {
  getAll: (params) => api.get('/notifications', { params }).then(unwrap),
  send: (data) => api.post('/notifications', data).then(unwrap).then((result) => result?.notification ?? result),
  markAsRead: (id) => api.put(`/notifications/${id}/read`).then(unwrap),
  markAllRead: () => api.put('/notifications/read-all').then(unwrap),
  remove: (id) => api.delete(`/notifications/${id}`).then(unwrap),
}
